import { Pipe, PipeTransform } from '@angular/core';
import { ChipVariants } from '@shared/components/chip/chip.component';

import { Région } from '../../administration/gestion-sites/model/région.model';
import { ÉTAT_GROUPE, étatGroupeOrdre } from '../../offre-regionale/enum/état-groupe.enum';

@Pipe({
  name: 'getEtatRegionVariant',
})
export class GetEtatRegionVariantPipe implements PipeTransform {
  transform(région: Région): ChipVariants['variant'] {
    const groupes = région.sites.flatMap((x) => x.etapes).flatMap((x) => x.groupes ?? []);
    if (!groupes.length) return 'default';

    const état = groupes
      .map((x) => x.etat)
      .reduce((min, current) => (étatGroupeOrdre[current] < étatGroupeOrdre[min] ? current : min));

    switch (état) {
      case ÉTAT_GROUPE.A_FAIRE:
        return 'default';
      case ÉTAT_GROUPE.A_VALIDER:
        return 'informative';
      case ÉTAT_GROUPE.VALIDE:
        return 'positive';
      case ÉTAT_GROUPE.REJETE:
        return 'negative';
    }
  }
}
